export default __webpack_public_path__ + "static/media/coron.87d30e3d.svg";